import { Box, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { GetPendingSRA } from '../Utils/ApiCalls'
import MorePendingSRA from './MorePendingSra';
import MoreSRA from './MoreSRA';
import PendingIQA from './PendingIQA';
import TableRow from './TableRow'
import RejectAction from './RejectAction';
import { configuration } from '../Utils/config';
import Pagination from './Pagination';
import SearchComponent from './SearchComponent';

export default function SraTechApproval() {

    const [Data, setData] = useState([]);
    const [SraID, setSraID] = useState("");
    const [Id, setId] = useState("");
    const [HandleMoreSRA, setHandleMoreSRA] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [SearchText, setSearchText] = useState("");

    //get current post

    const [CurrentPage, setCurrentPage] = useState(1);
    const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
    const indexOfLastSra = CurrentPage * PostperPage;
    const indexOfFirstSra = indexOfLastSra - PostperPage;
    const currentData = Data?.slice(indexOfFirstSra, indexOfLastSra);
    //change page 
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }


    const AllSRA = async () => {
        let result = await GetPendingSRA()

        console.log("object pending sra", result);

        if (result.status == true) {
            setData(result.queryresult.sraproductdetails)

        }
    }

    const openApprove = (id) => {
        onOpen()
        setId(id)
    }

    const openSra = (id) => {
        setHandleMoreSRA(true)

        let single = Data.filter((item) => {
            return item._id == id
        })
        //single Data 
        setSraID(single)
    }


    useEffect(() => {

        AllSRA()

    }, [isOpen]);


    return (
        <Box>
            <SearchComponent SearchText={SearchText} setSearchText={(e) => setSearchText(e.target.value)} Keywords={"Suppliers, raisedBy, invoiceNo"} />
            <Box display={"block"} alignItems="flex-start" w={"100%"} height="70vh" minH={"70vh"} overflow="auto" _hover={{ overflow: "auto" }} bg="blue.blue200" mt="32px" rounded={"8px"}>

                <Text p="10px" textTransform="Capitalize" color="#fff" display={"flex"} justifyContent="flex-end">Total Pending Approval - {Data.length}</Text>




                <TableContainer w={"100%"} mt="32px" overflowX="auto" color="#fff"

                >
                    <Table variant='simple' size='sm' overflowX="auto" >
                        <Thead>
                            <Tr>
                                <Th color="#fff">S/N</Th>
                                <Th color="#fff">Suppliers </Th>
                                <Th color="#fff">Raised by</Th>
                                <Th color="#fff">Date received</Th>
                                <Th color="#fff">Invoice Number</Th>
                                <Th color="#fff">Status</Th>
                                <Th color="#fff">Rejection</Th>
                                <Th color="#fff">View More</Th>

                            </Tr>
                        </Thead>
                        <Tbody>

                            {
                                SearchText === "" ? (
                                    currentData?.map((item, i) => (
                                        <TableRow
                                            type="sraApprovalT"
                                            sn={i + 1}
                                            raised={item.sra?.raised}
                                            supplierName={item.sra?.suppliersname}
                                            status={item.status}
                                            dateReceived={moment(item.datereceived).format('DD/MM/YYYY')}
                                            invoiceNo={item.sra?.invoicenumber}
                                            onClick={() => openSra(item._id)}
                                            Approve={() => openApprove(item._id)}



                                        />
                                    ))
                                ) : (
                                    SearchText !== "" && currentData.filter(item => item.sra?.suppliersname?.toLowerCase().includes(SearchText) || item.sra?.raised?.toLowerCase().includes(SearchText) || item.sra?.invoicenumber?.toLowerCase().includes(SearchText)).length > 0 ? (

                                        currentData.filter(item => item.sra?.suppliersname?.toLowerCase().includes(SearchText) || item.sra?.raised?.toLowerCase().includes(SearchText) || item.sra?.invoicenumber?.toLowerCase().includes(SearchText)).
                                            map((item, i) => (
                                                <TableRow
                                                    type="sraApprovalT"
                                                    sn={i + 1}
                                                    raised={item.sra?.raised}
                                                    supplierName={item.sra?.suppliersname}
                                                    status={item.status}
                                                    dateReceived={moment(item.datereceived).format('DD/MM/YYYY')}
                                                    invoiceNo={item.sra?.invoicenumber}
                                                    onClick={() => openSra(item._id)}
                                                    Approve={() => openApprove(item._id)}



                                                />
                                            ))
                                    ) : (

                                        <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>
                                    )

                                )


                            }


                        </Tbody>

                    </Table>
                </TableContainer>
                <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data?.length} paginate={paginate} />

                <MorePendingSRA isOpen={HandleMoreSRA} onClose={() => setHandleMoreSRA(false)} singleData={SraID} />
                <RejectAction isOpen={isOpen} onClose={onClose} id={Id} state="ApproveSra" />

            </Box>
        </Box>
    )
}
